import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=e53f9ab6&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=ts&"
export * from "./MessageItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=e53f9ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53f9ab6",
  null
  
)

export default component.exports